const rtf = new Intl.RelativeTimeFormat("ru", {
    localeMatcher: "best fit", // other values: "lookup"
    numeric: "always", // other values: "auto"
    style: "long", // other values: "short" or "narrow"
});
export function timeSince(date) {

    var seconds = Math.floor((+new Date() - date) / 1000);

    var interval = seconds / 31536000;

    if (interval > 1) {
        return rtf.format(-Math.floor(interval), "year");
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return rtf.format(-Math.floor(interval), "month");

    }
    interval = seconds / 86400;
    if (interval > 1) {
        // return Math.floor(interval) + " дней";
        return rtf.format(-Math.floor(interval), "day");
        
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return rtf.format(-Math.floor(interval), "hour");
        return Math.floor(interval) + " часов";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return rtf.format(-Math.floor(interval), "minute");
        return Math.floor(interval) + " минут";
    }
        return rtf.format(-Math.floor(interval), "second");
        return Math.floor(seconds) + " секунд";
}
export function leadZero(n: number) :string {
    if (n < 10) {
        return '0' + n.toString();
    }
    return n.toString();
}
